module.exports = __webpack_public_path__ + "static/img/ruipai.a685ba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/ruipai.png
// module id = AG86
// module chunks = 34